class Referral {
    constructor(tag) {
        this.tag = tag;
        this.value = this.normalizeValue(localStorage.getItem(this.tag));
    }

    getTagFromUrl() {
        let strRegex = `${this.tag}=` + "(\\w+)";
        let query = location.search.match(new RegExp(strRegex), "i");
        return this.normalizeValue(query ? query[1] : null);
    }

    getValue() {
        return this.getTagFromUrl() || this.value;
    }

    setValue() {
        this.value = this.getTagFromUrl() || this.value;

        if (this.value === null) {
            localStorage.removeItem(this.tag);

            return;
        }

        localStorage.setItem(this.tag, this.value);
    }

    normalizeValue(value) {
        if (typeof value !== "string") {
            return null;
        }

        let normalizedValue = value.trim();

        return normalizedValue === "" || normalizedValue.toLowerCase() === "null"
            ? null
            : normalizedValue;
    }

    addValueToUrl() {
        let params = this.getAllUrlParams();
        if (this.value !== null) params[this.tag] = this.value;
        let base_url = location.origin;
        base_url += location.pathname;
        base_url +=
            "?" +
            Object.keys(params)
                .map((key) => key + "=" + params[key])
                .join("&");

        this.copyLink(base_url);
    }

    copyLink(base_url) {
        this.copyToClipboard(base_url).then(
            function () {
                console.log(
                    "Async: Copying to clipboard was successful!" + base_url
                );
            },
            function (err) {
                console.error("Async: Could not copy text: ", err);
            }
        );
    }

    copyToClipboard(textToCopy) {
        if (navigator.clipboard && window.isSecureContext) {
            return navigator.clipboard.writeText(textToCopy);
        } else {
            let textArea = document.createElement("textarea");
            textArea.value = textToCopy;
            textArea.style.position = "fixed";
            textArea.style.left = "-999999px";
            textArea.style.top = "-999999px";
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            return new Promise((res, rej) => {
                document.execCommand("copy") ? res() : rej();
                textArea.remove();
            });
        }
    }

    getAllUrlParams() {
        var url = location.href;
        // get query string from url (optional) or window
        var queryString = url
            ? url.split("?")[1]
            : window.location.search.slice(1);

        // we'll store the parameters here
        var obj = {};

        // if query string exists
        if (queryString) {
            // stuff after # is not part of query string, so get rid of it
            queryString = queryString.split("#")[0];

            // split our query string into its component parts
            var arr = queryString.split("&");

            for (var i = 0; i < arr.length; i++) {
                // separate the keys and the values
                var a = arr[i].split("=");

                // set parameter name and value (use 'true' if empty)
                var paramName = a[0];
                var paramValue = typeof a[1] === "undefined" ? true : a[1];

                // (optional) keep case consistent
                paramName = paramName.toLowerCase();
                if (typeof paramValue === "string")
                    paramValue = paramValue.toLowerCase();

                // if the paramName ends with square brackets, e.g. colors[] or colors[2]
                if (paramName.match(/\[(\d+)?\]$/)) {
                    // create key if it doesn't exist
                    var key = paramName.replace(/\[(\d+)?\]/, "");
                    if (!obj[key]) obj[key] = [];

                    // if it's an indexed array e.g. colors[2]
                    if (paramName.match(/\[\d+\]$/)) {
                        // get the index value and add the entry at the appropriate position
                        var index = /\[(\d+)\]/.exec(paramName)[1];
                        obj[key][index] = paramValue;
                    } else {
                        // otherwise add the value to the end of the array
                        obj[key].push(paramValue);
                    }
                } else {
                    // we're dealing with a string
                    if (!obj[paramName]) {
                        // if it doesn't exist, create property
                        obj[paramName] = paramValue;
                    } else if (
                        obj[paramName] &&
                        typeof obj[paramName] === "string"
                    ) {
                        // if property does exist and it's a string, convert it to an array
                        obj[paramName] = [obj[paramName]];
                        obj[paramName].push(paramValue);
                    } else {
                        // otherwise add the property
                        obj[paramName].push(paramValue);
                    }
                }
            }
        }

        return obj;
    }
}

export default Referral;
